import apiClient from './apiClient';

export async function getApplyForm(jobSlug = '') {
  const response = await apiClient.get('/api/apply-form', {
    params: jobSlug ? { job: jobSlug } : {},
  });
  return response.data;
}

export async function submitApplication({ jobSlug, jobTitle, responses, files }) {
  const formData = new FormData();
  formData.append('payload', JSON.stringify({ jobSlug, jobTitle, responses }));

  Object.entries(files || {}).forEach(([fieldKey, file]) => {
    if (file) {
      formData.append(fieldKey, file);
    }
  });

  const response = await apiClient.post('/api/applications', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
}
